
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { configStore, uiStore } from "@/store/store";
import MultiselectInput from "@/components/Reusable/CustomInputs/MultiselectInput.vue";
import DropdownInput from "@/components/Reusable/CustomInputs/DropdownInput.vue";
import { BreakpointOptions } from "@/types/controls";

@Component({
  components: { DropdownInput, MultiselectInput }
})
export default class BreakpointInput extends Vue {
  @Prop()
  value: unknown;

  @Prop({
    default: () => {
      return {};
    }
  })
  breakpointOptions!: BreakpointOptions;

  get multiple() {
    return this.breakpointOptions.multiple;
  }

  get includeNever() {
    return this.breakpointOptions.enableNever;
  }

  get items() {
    const includeCustomBreakpoints =
      uiStore.settings.includeCustomBreakpointsInBreakpointsDropdown &&
      !this.breakpointOptions.banCustomBreakpoints;

    const breakpoints = (
      includeCustomBreakpoints
        ? configStore.breakpoints
        : configStore.builtinBreakpoints
    ).map(breakpoint => {
      return {
        text: breakpoint.label,
        value: breakpoint.id
      };
    });

    if (this.includeNever && !this.multiple) {
      breakpoints.push({ text: "Never", value: "never" });
    }

    return breakpoints;
  }

  edit(breakpointId: string | undefined) {
    this.$emit("input", breakpointId || "");
  }
}
